import _ from 'lodash';
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import OffersTable from '../offers-table/OffersTable';
import OffersList from '../offers-list/OffersList';
import { offersSchema } from '../../offers-page-schemas';

export class OffersComponent extends Component {
    render() {
        return (
            <div>
                <div className="sm-show">
                    <OffersTable offers={this.props.offers}></OffersTable>
                </div>
                <div className="sm-hide" data-cy="offersContainerMobile">
                    <OffersList offers={this.props.offers}></OffersList>
                </div>
            </div>
        );
    }
}

OffersComponent.propTypes = {
    offers: offersSchema.isRequired
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(OffersComponent);
